var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChewronForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "iconChewronForward"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.96845 7.79117C6.8492 7.90651 6.8492 8.0935 6.96845 8.20883L10.9106 12.0213C11.0298 12.1367 11.0298 12.3236 10.9106 12.439L9.90291 13.4135C9.78365 13.5288 9.59031 13.5288 9.47105 13.4135L4.08944 8.20883C3.97019 8.09349 3.97019 7.90651 4.08944 7.79117L9.47105 2.5865C9.59031 2.47117 9.78365 2.47117 9.90291 2.5865L10.9106 3.56102C11.0298 3.67635 11.0298 3.86334 10.9106 3.97868L6.96845 7.79117Z",
    fill: "#002CFB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChewronForward);
export default __webpack_public_path__ + "static/media/iconChewronForward.6eed13fc955347578e278c5024757b4f.svg";
export { ForwardRef as ReactComponent };